import email_logo from "../../Images/images/email.png";
import location_logo from "../../Images/images/location.png";
import phone_logo from "../../Images/images/phone.png";
import black_logo from "../../Images/black_logo.png";
import sign from "../../Images/sign.png";


export async function footer (billing) {
    async function getBase64ImageFromURL(url) {
        // console.log(url);
        return new Promise((resolve, reject) => {
          var img = new Image();
          img.setAttribute("crossOrigin", "anonymous");
          img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
          };
          img.onerror = (error) => {
            console.error("Error loading image:", url, error);
            reject(error);
          };
          img.src = url;
        });
      }
    const headerImages = {
        backgroundImage: await getBase64ImageFromURL(black_logo),
        Sign: await getBase64ImageFromURL(sign),
        Locate: await getBase64ImageFromURL(location_logo),
        phone: await getBase64ImageFromURL(phone_logo),
        email: await getBase64ImageFromURL(email_logo)
      };

      if(billing === 'billing'){
        return [
            {   
                margin: [15, 10, 15, 0],
                stack:[
                    {
                        margin:[0,5,0,0],
                        columns:[
                            {
                                text:'TERMS & CONDITIONS',
                                fontSize:9,
                            },
                            {
                                text:'E. & O.E.',
                                fontSize:9,
                                alignment:'center'
                            },
                            {
                                text:'FOR,',
                                fontSize:9,
                                alignment:'center'

                            },
                            {
                                text:'KIRTI ROADLINES',
                                fontSize:9,
                                bold:true,
                                alignment:'right'
                            },
                        ]
                    },
                    {
                      canvas: [
                        {
                          type: "line",
                          x1: 0,
                          y1: 5,
                          x2: 150,
                          y2: 5,
                          lineWidth: 2,
                        },
                      ],
                      margin: [0, 0, 0, 2],
                    },
                    {
                        margin:[0,5,0,0],
                        height:70,
                        columns:[
                            {
                                text:'SUBJECT TO AHMEDABAD JURISDICTION',
                                fontSize:9,
                            },
                            {
                                image: headerImages.Sign,
                                width: 60,
                            },
                        ]
                    },
                    {
                        margin:[0,5,0,0],
                        columns:[
                            {
                                width:'70%',
                                text:`PAYMENT BY PAYEE'S A/C CHEQUE / DRAFS ONLY IN FAVOUR OF THE KIRTI ROADLINES`,
                                fontSize:9,
                            },
                            {
                                text:'AUTHORIZED SIGNATORY',
                                fontSize:9,
                                bold:true,
                                alignment:'right'
                            },
                            
                        ]
                    },
                    {
                        canvas:[
                            {
                                type: 'rect',
                                x: 0,
                                y: 5,
                                w: 563,  // width of the rectangle
                                h: 2,   // height of the rectangle
                                color: 'black'
                              }
                        ]
                    },
                    {
                      canvas:[
                          {
                              type: 'rect',
                              x: 0,
                              y: 5,
                              w: 563,  // width of the rectangle
                              h: 20,   // height of the rectangle
                          }
                      ]
                    },
                    {
                      alignment:'center',
                      absolutePosition:{x:0, y:86},
                      text:'THIS IS A COMPUTER GENERATED INVOICE',
                      bold:true,
                      fontSize:10
                    }
                ]
            }
        ]
      }else{
        return [
            {
              columns: [
                {
                  text: `TERM'S & CONDITION'S OF CARRIAGE OWNER'S RISK`,
                  // absolutePosition: { x: 20, y: 20 },
                  color: "#000",
                  fontSize: 9,
                  bold: true,
                  margin: [35, 10, 0, 0],
                  decoration: "underline",
                },
                {
                  stack: [
                    { 
                      text: `VALUE: AS PER INVOICE`,
                      // absolutePosition: { x: 295, y: 20 },
                      color: "#000",
                      fontSize: 7,
                      bold: true,
                      margin: [0, 10, 35, 0],
                      alignment: "right",
                    },
                    { 
                      text: `SERVICE TAX LIABILITY OF CONSIGNOR`,
                      // absolutePosition: { x: 295, y: 20 },
                      color: "#000",
                      fontSize: 7,
                      margin: [0, 2, 35, 0],
                      alignment: "right",
                      bold:true
                    },
                  ]
                }
              ],
            },
            {
              alignment: "justify",
              columns: [
                {
                  width: 350,
                  text: `WHERE THE GOODS HAVE BEEN LOST DESTROYED, DAMAGED OR HAVE DETERIORATED, THE COMPENSATION SHALL NOT BE PAYABLE BY THE TRANSPORT OPERATOR. IF NATURE CALAMITY OR ANY TYPE OF ACCIDENT OCCURS, BOTH PARTIES CONSIGNOR AND CONSIGNEE ARE LIABLE FOR THE GOODS PAYMENTS.`,
                  // absolutePosition: { x: 20, y: 35 },
                  color: "#000",
                  fontSize: 7,
                  bold: false,
                  margin: [35, 5, 0, 0],
                },
                {
                  absolutePosition: { x: 460, y: 32 },
                  image: headerImages.Sign,
                  width: 90,
                },
                {
                  text: `FOR KIRTI ROADLINES`,
                  absolutePosition: { x: 455, y: 60 },
                  color: "#000",
                  fontSize: 9,
                  bold: true,
                },
              ],
            },
            {
              columns: [
                {
                  text: `THANK YOU FOR BUSINESS WITH US`,
                  color: "#000",
                  fontSize: 10,
                  bold: true,
                  alignment: "center",
                  margin: [0, 10, 0, 0],
                  font: "PTSerifRegular",
                },
              ],
            },
          ];
      }

  }